import "@aws-amplify/ui-react/styles.css";
import { 
  Box, 
  Heading,
  Stack,
  Center,
  Image,
  Text 
} from '@chakra-ui/react'
import React from "react";

class Home extends React.Component<{message?: string}> {
    render() {
      return (<>
      <Box alignItems="center" justifyContent="space-between" mb={20}>
        <Heading textAlign='center' mt={10} mb={10}>{this.props.message ?? "Page Not Found"}</Heading>
        <Center>
          <Stack alignContent='center' justifyContent='center'>
            <Center>
              <Image boxSize='192px' src="/logotransp192.png" />
            </Center>
            <Text>Enfield Federals - Past Players & Supporters Club</Text>
          </Stack>
        </Center>
      </Box>
    </>
    )
  }
}

export default Home;